import { HttpClient } from '@angular/common/http';
import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogListContactComponent} from '../../components/dialog/dialogListContact/dialog-list-contact-component';
import {CUtilit} from '../../classes/utilit';
import {DialogOrderNoteComponent} from '../../components/dialog/dialog-order-note/dialog-order-note.component';

@Component({
  selector: 'app-dev-test',
  templateUrl: './dev-test.component.html',
  styleUrls: ['./dev-test.component.css']
})
export class DevTestComponent implements OnInit {

  @ViewChild('canvas', {static: true}) refCanvas!: ElementRef<HTMLCanvasElement>;

  text: string = '';

  constructor(private http: HttpClient,
              private translate: TranslateService,
              private mDialog: MatDialog) { }

  async ngOnInit() { }

  onclick() {
    DialogOrderNoteComponent.displayDialog(this.mDialog, this.text, false).afterClosed().toPromise().then(value => {
      if (value === undefined)
        console.log('closed');
      else {
        console.log('Update with: ', value);
        this.text = value;
      }
    });
    /*DialogListContactComponent.openDialog(this.mDialog, CUtilit.getSelectedSiteCode()).then(value => {
      this.text = 'Then opendialog: ' + (value ? JSON.stringify(value) : String(value));
      console.log('Then opendialog, ', value);
    });

     */
    //DialogContactComponent.openDialog(this.mDialog);
  }
}
